import { API_ROOT_URL } from '../config';
import { handleResponse } from '../helpers';
import axios from 'axios';
import moment from 'moment';

export const appointmentService = {
	AdminCreateAppointment,
};

function AdminCreateAppointment(current_time, slotTime, patient_id, counsellor_id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify({
			current_time: current_time,
			date_time: slotTime,
			patient_id: patient_id,
            counsellor_id: counsellor_id,
			payment: 'notrequired',
		}),
	};
	return fetch(`${API_ROOT_URL}/administrator/create-appointment/`, requestOptions).then((handleResponse) => {
		return handleResponse;
	});
}


// WEBPACK FOOTER //
// ./src/services/appointment.service.js